// KD-3643 — the verdict a product instance (a program or a hotel stay) reports
// up to the trip through `registerExperienceWarning` / `registerHotelWarning`,
// so the trip is not bookable while one of its products cannot be sold.
//
// Three outcomes: nothing to report (`null`), a verdict not settled yet — the
// request is still in flight, blocking but with nothing to explain — and a
// product that plainly cannot be booked.
export const PRODUCT_AVAILABILITY = {
  PENDING: 'pending',
  UNAVAILABLE: 'unavailable',
} as const;
